import { Routes } from '@angular/router';

import { CmsPageGuard, PageLayoutComponent } from '@spartacus/storefront';

import { rpProductsCategoryMatcher } from './matchers/rp-products-category.matcher';
import { AccountModuleGuard } from './guards/account-module.guard';
import { CartModuleGuard } from './guards/cart-module.guard';
import { CheckoutStep2Guard } from './guards/checkout-step-2.guard';
import { CheckoutStep3Guard } from './guards/checkout-step-3.guard';
import { FreeContentCgvPageComponent } from './templates/free-content-cgv-page/free-content-cgv-page.component';
import { accessoryModuleGuard } from './guards/accessory-module.guard';
import { ProductModuleGuard } from './guards/product-module.guard';
import { ProductComparatorModuleGuard } from './guards/product-comparator-module.guard';
import { SearchModuleGuard } from './guards/search-module.guard';
import { SearchResultGuard } from './guards/search-result.guard';
import { ProductGuard } from './guards/product.guard';
import { CategoryModuleGuard } from './guards/category-module.guard';
import { SubCategoryGuard } from './guards/sub-category.guard';
import { EmptyPageComponent } from './templates/empty-page/empty-page.component';
import { ifuProductsCategoryMatcher } from './matchers/ifu-products-category.matcher';
import { faqProductsCategoryMatcher } from './matchers/faq-products-category.matcher';
import { recipeDetailsMatcher } from './matchers/recipe-details.matcher';

export const accountRoutes: Routes = [
  {
    matcher: rpProductsCategoryMatcher,
    data: { pageLabel: '/my-products' },
    component: PageLayoutComponent,
    canActivate: [AccountModuleGuard, CmsPageGuard]
  },
  {
    path: 'return-products/:orderCode/:consignmentCode',
    data: { pageLabel: '/return-products' },
    component: PageLayoutComponent,
    canActivate: [AccountModuleGuard, CmsPageGuard]
  },
  {
    path: 'my-account',
    component: PageLayoutComponent,
    canActivate: [AccountModuleGuard, CmsPageGuard]
  },
  {
    path: 'my-account-dashboard',
    component: PageLayoutComponent,
    canActivate: [AccountModuleGuard, CmsPageGuard]
  },
  {
    path: 'my-orders',
    component: PageLayoutComponent,
    canActivate: [AccountModuleGuard, CmsPageGuard]
  },
  {
    path: 'my-newsletters',
    component: PageLayoutComponent,
    canActivate: [AccountModuleGuard, CmsPageGuard]
  },
  {
    path: 'my-repairers',
    component: PageLayoutComponent,
    canActivate: [AccountModuleGuard, CmsPageGuard]
  },
  {
    path: 'refer-a-friend',
    component: PageLayoutComponent,
    canActivate: [AccountModuleGuard, CmsPageGuard]
  }
];

export const cartRoutes: Routes = [
  {
    path: 'checkout/express/review/:orderCode',
    data: { pageLabel: '/checkout/express/review' },
    component: PageLayoutComponent,
    canActivate: [CartModuleGuard, CmsPageGuard]
  },
  {
    path: 'order-confirmation/:orderCode',
    data: { pageLabel: '/order-confirmation' },
    component: PageLayoutComponent,
    canActivate: [CartModuleGuard, CmsPageGuard]
  },
  {
    path: 'donations/:orderCode',
    data: { pageLabel: '/donations' },
    component: PageLayoutComponent,
    canActivate: [CartModuleGuard, CmsPageGuard]
  },
  {
    path: 'guest-checkout/order/:orderCode',
    data: { pageLabel: '/order-confirmation' },
    component: PageLayoutComponent,
    canActivate: [CartModuleGuard, CmsPageGuard]
  },
  {
    path: 'received-order-confirmation/:orderCode',
    data: { pageLabel: '/received-order-confirmation' },
    component: PageLayoutComponent,
    canActivate: [CartModuleGuard, CmsPageGuard]
  },
  {
    path: 'checkout/multi/choose-delivery',
    component: PageLayoutComponent,
    canActivate: [CartModuleGuard, CmsPageGuard, CheckoutStep2Guard]
  },
  {
    path: 'checkout/multi/choose-payment-method',
    component: PageLayoutComponent,
    canActivate: [CartModuleGuard, CmsPageGuard, CheckoutStep3Guard],
    children: [
      {
        path: 'termsofsale',
        component: FreeContentCgvPageComponent,
        outlet: 'modal'
      }
    ]
  },
  {
    path: 'checkout/multi/adyen/:orderCode/payment/continue',
    data: { pageLabel: '/checkout/multi/choose-payment-method' },
    component: PageLayoutComponent,
    canActivate: [CartModuleGuard, CmsPageGuard]
  },
  {
    path: 'cart',
    component: PageLayoutComponent,
    canActivate: [CartModuleGuard, CmsPageGuard]
  },
  {
    path: 'cart/:cartId',
    data: { pageLabel: '/cart' },
    component: PageLayoutComponent,
    canActivate: [CartModuleGuard, CmsPageGuard]
  }
];

export const catalogRoutes: Routes = [
  {
    path: 'accessory/home',
    canActivate: [accessoryModuleGuard, CmsPageGuard],
    component: PageLayoutComponent
  },
  {
    path: 'product-comparator',
    canActivate: [ProductComparatorModuleGuard, CmsPageGuard],
    component: PageLayoutComponent
  },
  {
    path: 'search',
    runGuardsAndResolvers: 'pathParamsOrQueryParamsChange',
    canActivate: [SearchModuleGuard, CmsPageGuard, SearchResultGuard],
    component: PageLayoutComponent
  },
  {
    path: null,
    canActivate: [ProductModuleGuard, CmsPageGuard, ProductGuard],
    component: PageLayoutComponent,
    data: { cxRoute: 'product' }
  },
  {
    path: null,
    canActivate: [CategoryModuleGuard, CmsPageGuard, SubCategoryGuard],
    component: PageLayoutComponent,
    data: { cxRoute: 'category' }
  },
  {
    path: null,
    canActivate: [CmsPageGuard],
    component: PageLayoutComponent,
    data: { cxRoute: 'recipeCategory' }
  }
];

export const commonRoutes: Routes = [
  {
    path: 'error/:code',
    component: EmptyPageComponent
  },
  {
    path: 'previewServlet',
    redirectTo: 'cx-preview'
  },
  {
    matcher: faqProductsCategoryMatcher,
    data: { pageLabel: '/faq/csc/products' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard]
  },
  {
    matcher: ifuProductsCategoryMatcher,
    data: { pageLabel: '/instructions-for-use' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard]
  }
];

export const recipeRoutes: Routes = [
  {
    matcher: recipeDetailsMatcher,
    children: [
      {
        path: '',
        data: { pageLabel: '/recipe' },
        component: PageLayoutComponent,
        canActivate: [CmsPageGuard]
      },
      {
        path: 'detail/:sourceSystem/:recipeName/:recipeId',
        data: { pageLabel: '/recipe/detail' },
        component: PageLayoutComponent,
        canActivate: [CmsPageGuard]
      },
      {
        path: 'detail/:sourceSystem/:recipeName/v1/recipes/:recipeId',
        data: { pageLabel: '/recipe/detail' },
        component: PageLayoutComponent,
        canActivate: [CmsPageGuard]
      }
    ]
  }
];
